export { default } from './LayoutNoCTA';
